import styled from "styled-components";

export const SH = styled.h2`
    font-size: 14px;
    font-weight: 300;
    text-transform: uppercase;
    letter-spacing: .18em;
`